import { createDomain, deleteDomain, editDomain, getDomains } from './domain.action';
export { domainReducer } from './domain.reducer';
export { watchDomains } from './domain.saga';

export const domainActions = {
    /** Domains */
    getDomains,
    createDomain,
    editDomain,
    deleteDomain,
    /** End */
};
